// export enum Config {
//  apiUrl = "http://localhost:8090/api/v1",
//  apiSecureUrl = "http://localhost:8090/api/v1/secure",
//  siteUrl = "localhost:3000",
//  defaultLanguage = "de",
//  version = "v1",
// }
///-------Local----------------//
// export enum Config {
//     apiUrl = "https://fdd7-103-156-208-252.ngrok-free.app/api/v1",
//     apiSecureUrl = "https://fdd7-103-156-208-252.ngrok-free.app/api/v1/secure",
//     siteUrl = "localhost:3000",
//     defaultLanguage = "en",
//     version = "v1.0.0",
// }

// export enum Config {
// 	apiUrl = "http://192.168.2.7:8081/api/v1",
// 	apiSecureUrl = "http://192.168.2.7:8081/api/v1/secure",
// 	siteUrl = "localhost:3000",
// 	defaultLanguage = "de",
// 	version = "v1",
// }

export enum Config {
	apiUrl = "https://qa.api.talentquest.simplogics.com/api/v1",
	apiSecureUrl = "https://qa.api.talentquest.simplogics.com/api/v1/secure",
	siteUrl = "localhost:3000",
	defaultLanguage = "de",
	version = "v1",
}
